import { TaskItem } from '@/entities/tasks/model/types'
import { tempAssetsExports } from '@/tempAssetsExports.ts'
import yesCoin from 'public/assets/webp/tasks/yesCoin.webp'
import pokergram from 'public/assets/webp/tasks/pokergram.webp'

export function isTaskCooledDown(task: TaskItem): boolean {
  if (!task.repeatable) {
    return false
  }
  // если еще не нажали ни разу
  if (task.next_claim_available === null) {
    return true
  }
  // если откат прошел
  if (new Date(task.next_claim_available) < new Date()) {
    return true
  }
  return false
}

export const sortByPrioritizedTasks = (tasks: TaskItem[], prioritized: string[]) => {
  const prioritySet = new Set(prioritized)

  const prioritizedPart = tasks
    .filter((task) => prioritySet.has(task.name))
    .sort((a, b) => prioritized.indexOf(a.name) - prioritized.indexOf(b.name))

  const restPart = tasks.filter((task) => !prioritySet.has(task.name))

  return [...prioritizedPart, ...restPart]
}

export const steamOnTasks = ['addSteam', 'addEpic', 'openPs5', 'openSteamOn', 'x']

export const prioritizedTasks = [
  'yesCoin',
  'tradeStormTrade',
  'tradeUpscale',
  'joinUpscale',
  'boinkersMoon',
  'joinUpscale',
  'boinkersSlut',
  'pokergram',
]

const steam = 'https://storage.googleapis.com/gamed-games-bucket/pictures/steam.webp'
const epic = 'https://storage.googleapis.com/gamed-games-bucket/pictures/Epic%20Games.webp'

export const eventTasks = [...steamOnTasks]
export const TaskImageObject = {
  addSteam: steam,
  vote: tempAssetsExports.tasks.vote,
  addEpic: epic,
  x: tempAssetsExports.tasks.x,
  xPost: tempAssetsExports.tasks.x,
  updateProgress: tempAssetsExports.tasks.updateProgress,
  gamedCommunity: tempAssetsExports.tasks.telegram,
  gamedChat: tempAssetsExports.tasks.telegram,
  addToHomeScreen: tempAssetsExports.tasks.general,
  addEmoji: tempAssetsExports.tasks.general,
  streaks: tempAssetsExports.tasks.defaultTaskIcon,
  tApps: tempAssetsExports.tasks.defaultTaskIcon,
  boost: tempAssetsExports.tasks.general,
  postStory: tempAssetsExports.tasks.defaultTaskIcon,
  friends3: tempAssetsExports.tasks.friends,
  friends5: tempAssetsExports.tasks.friends,
  friends1: tempAssetsExports.tasks.friends,
  openSteamOn: tempAssetsExports.tasks.defaultTaskIcon,
  openPs5: tempAssetsExports.tasks.defaultTaskIcon,
  tonConnect: tempAssetsExports.tasks.ton,
  tonTransaction: tempAssetsExports.tasks.ton,
  steam,
  play: tempAssetsExports.tasks.defaultTaskIcon,
  yesCoin,
  tradeStormTrade: tempAssetsExports.tasks.tradeStormTrade,
  tradeUpscale: tempAssetsExports.tasks.tradeUpscale,
  boinkersMoon: tempAssetsExports.tasks.boinkersMoon,
  boinkersSlut: tempAssetsExports.tasks.boinkersSlot,
  pokergram,
  joinUpscale: tempAssetsExports.tasks.x,
} as const
